import React, { useState } from 'react';
import './PrivacyPolicies.css';

const PrivacyPolicies = ({ onAgree, onDecline }) => {
  const [isOpen, setIsOpen] = useState(true);

  const handleAgree = () => {
    if (onAgree) {
      onAgree();
    } else {
      localStorage.setItem('privacyAccepted', 'true');
      setIsOpen(false);
    }
  };

  const handleDecline = () => {
    if (onDecline) {
      onDecline();
    } else {
      setIsOpen(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="privacy-modal-overlay">
      <div className="privacy-modal">
        <h2>Privacy Policy Agreement</h2>
        <div className="privacy-content" style={{ maxHeight: '400px', overflowY: 'auto', marginBottom: '20px' }}>
          <section>
            <h3>Information We Collect</h3>
            <p>We may collect personal information such as your name, email address, phone number, and IP address. We also collect data on your browsing behavior, preferences, and cookies to enhance your experience on our website.</p>
          </section>
          <section>
            <h3>Reason for Collection</h3>
            <p>The data we collect helps us personalize your experience, process appointments, send timely updates, and improve our services. It also aids in security and performance monitoring.</p>
          </section>
          <section>
            <h3>How We Collect Information</h3>
            <p>Information is gathered through online forms, cookies, server logs, and analytics tools. Your interaction with our website automatically records data in accordance with our security practices.</p>
          </section>
          <section>
            <h3>Data Usage</h3>
            <p>Your data is used to send notifications regarding appointments, product updates, and relevant communications. We utilize this data to analyze website performance, enhance our service offerings, and personalize your experience. Your data is never sold to third parties.</p>
          </section>
          <section>
            <h3>Privacy Policy Updates</h3>
            <p>We will inform you of any updates to our privacy policy via email and on-site notifications, ensuring you are always informed about any changes to our data practices.</p>
          </section>
          <section>
            <h3>Data Protection Statement</h3>
            <p>We are committed to protecting your personal data with state-of-the-art security measures, including encryption, secure storage, and regular audits to prevent unauthorized access and disclosure.</p>
          </section>
          <section>
            <h3>Privacy Policy Compliance</h3>
            <p>Our privacy practices comply with industry standards and legal requirements. We continuously monitor and update our policies to ensure full compliance with data protection laws.</p>
          </section>
          <section>
            <h3>Location and Data Protection Laws</h3>
            <p>We adhere to the California Consumer Privacy Act (CCPA), as well as data protection laws in North Dakota, South Dakota, and Minnesota, ensuring that your rights are protected no matter where you are located.</p>
          </section>
        </div>
        <div className="privacy-modal-buttons">
          <button onClick={handleAgree} className="agree-button">Agree</button>
          <button onClick={handleDecline} className="decline-button">Decline</button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicies;
